import React from 'react';

export default ({ children }) => <th>{children}</th>;
